import { useState } from "react";
import { toast } from "sonner";
import { submitPitch } from "@/lib/api";
import { HOME } from "@/constants/testIds";

export const PitchForm = () => {
  const [form, setForm] = useState({ name: "", email: "", business_name: "", borough: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Name, email and message are required");
      return;
    }
    setLoading(true);
    try {
      await submitPitch(form);
      toast.success("Pitch received. We'll be in touch within 48 hours.");
      setForm({ name: "", email: "", business_name: "", borough: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || "Could not send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-0 border-b border-white/20 focus:border-[#FF3B30] outline-none py-3 text-lg placeholder:text-white/30 transition-colors";

  return (
    <form id="pitch" onSubmit={onSubmit} data-testid={HOME.pitchForm} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Your name</label>
          <input data-testid={HOME.pitchName} value={form.name} onChange={set("name")} className={field} placeholder="Alex" />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Email</label>
          <input data-testid={HOME.pitchEmail} value={form.email} onChange={set("email")} type="email" className={field} placeholder="alex@yourshop.co.uk" />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Business name</label>
          <input data-testid={HOME.pitchBusiness} value={form.business_name} onChange={set("business_name")} className={field} placeholder="Optional" />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Borough</label>
          <input data-testid={HOME.pitchBorough} value={form.borough} onChange={set("borough")} className={field} placeholder="Hackney" />
        </div>
      </div>
      <div>
        <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">What are you trying to fix?</label>
        <textarea data-testid={HOME.pitchMessage} value={form.message} onChange={set("message")} rows={4} className={field + " resize-none"} placeholder="We get 600 reviews but no online bookings…" />
      </div>
      <button
        data-testid={HOME.pitchSubmit}
        type="submit"
        disabled={loading}
        className="bg-[#FF3B30] text-white px-8 py-4 font-display font-bold tracking-tight text-lg hover:bg-[#E6352B] disabled:opacity-50 transition-colors"
      >
        {loading ? "Sending…" : "Pitch us your high street →"}
      </button>
    </form>
  );
};

export default PitchForm;
